<div *ngIf="isLoading; else tableBlock" class="loading-block">
  <div class="loading-summary">
    <div class="loading-icon-shell">
      <mat-icon>receipt_long</mat-icon>
    </div>
    <div class="loading-copy">
      <span class="loading-eyebrow">Un momento</span>
      <h3>Preparando reporte de OS</h3>
      <p>
        Estamos cargando las órdenes disponibles para mostrar la información
        actualizada.
      </p>
    </div>
  </div>
  <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
</div>

<ng-template #tableBlock>
  <div class="filtering-indicator" *ngIf="isLoadingMore">
    <mat-progress-bar mode="indeterminate" color="accent"></mat-progress-bar>
    <span>
      Cargando más OS… {{ loadedCount }} cargadas. Los filtros se aplican sobre
      lo ya descargado.
    </span>
  </div>

  <div class="table-toolbar">
    <div class="table-toolbar-info">
      <span class="record-count">
        <mat-icon class="count-icon">table_rows</mat-icon>
        {{ visibleCount }} OS encontrada{{ visibleCount !== 1 ? 's' : '' }}
        <ng-container *ngIf="loadedCount">
          · {{ loadedCount }} cargada{{ loadedCount !== 1 ? 's' : '' }}
        </ng-container>
      </span>
      <span class="table-mode-help">
        Usa el paginador al final de la tabla para avanzar entre resultados.
      </span>
    </div>
  </div>

  <div class="table-surface" *ngIf="visibleCount > 0; else emptyState">
    <div class="table-wrapper">
      <mat-table
        [dataSource]="dataSource"
        matSort
        matSortDisableClear
        (matSortChange)="onSort($event)"
        class="orders-report-mat-table"
      >
        <ng-container matColumnDef="fileNumber" sticky>
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="monoHeader column-file"
            matTooltip="Número de file"
          >
            File
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="monoHeader column-file">
            <div class="file-info">
              <span class="file-name">{{ row.numberFile || '-' }}</span>
              <span class="file-number" *ngIf="row.fileExtend">{{
                row.fileExtend
              }}</span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numberOS">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="monoHeader column-os"
            matTooltip="Número de orden de servicio"
          >
            N° OS
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="monoHeader column-os">
            {{ row.numberOS || '-' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoOS">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="column-estado"
            matTooltip="Estado de la orden de servicio"
          >
            Estado
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="column-estado">
            <div class="estado-pill" [ngClass]="statusPillClass(row.estadoOS)">
              <span>{{ formatStatus(row.estadoOS) }}</span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nameProveedor">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="column-provider"
          >
            Proveedor
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            class="column-provider"
            [matTooltip]="row.nameProveedor || 'Sin proveedor'"
          >
            {{ row.nameProveedor || '-' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="serviceType">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="column-service"
            matTooltip="Tipo(s) de servicio en la OS"
          >
            Tipo
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            class="column-service"
            [matTooltip]="
              row.serviceTypes?.length ? row.serviceTypes.join(', ') : 'Sin tipo'
            "
          >
            {{
              row.serviceTypes?.length ? row.serviceTypes.join(', ') : '-'
            }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="paymentCondition">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="column-condition"
            matTooltip="Condición de pago del proveedor"
          >
            Cond. pago
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="column-condition">
            {{ row.paymentCondition || '-' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="scheduledPaymentDate">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="column-date"
            matTooltip="Fecha de pago programada"
          >
            Pago prog.
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="column-date text-muted">
            {{
              row.scheduledPaymentDate
                ? (row.scheduledPaymentDate | date: 'dd/MM/yyyy')
                : '-'
            }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="fechaPago">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="column-date"
            matTooltip="Fecha en que se registró el pago"
          >
            Pagado
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="column-date text-muted">
            {{ row.fechaPago ? (row.fechaPago | date: 'dd/MM/yyyy') : '-' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="totalGeneral">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="column-total"
            matTooltip="Monto base, comisión y total a pagar"
          >
            Total
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="column-total monoHeader">
            <ng-container *ngIf="row.commissionAmount != null; else plainTotal">
              <div class="os-pay-breakdown">
                <div class="os-pay-breakdown__row">
                  <span>Monto</span>
                  <span>{{ row.baseAmount | formatNumber }}</span>
                </div>
                <div class="os-pay-breakdown__row">
                  <span>{{ commissionLabel(row) }}</span>
                  <span>{{ row.commissionAmount | formatNumber }}</span>
                </div>
                <div class="os-pay-breakdown__row os-pay-breakdown__row--total">
                  <span>Total</span>
                  <span>{{ row.totalGeneral | formatNumber }}</span>
                </div>
              </div>
            </ng-container>
            <ng-template #plainTotal>
              {{
                row.totalGeneral != null
                  ? (row.totalGeneral | formatNumber)
                  : '-'
              }}
            </ng-template>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="currency">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="column-currency"
            matTooltip="Moneda del total"
          >
            Mon.
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="column-currency">
            {{ row.currency || '-' }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="actions" stickyEnd>
          <mat-header-cell
            *matHeaderCellDef
            class="column-actions"
            matTooltip="Documento PDF de la OS"
          >
            Doc.
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="column-actions">
            <button
              mat-icon-button
              type="button"
              class="btn-action-pdf"
              matTooltip="Ver PDF"
              matTooltipPosition="left"
              [disabled]="!row.orderId"
              (click)="openPdf.emit(row)"
            >
              <mat-icon>picture_as_pdf</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
      </mat-table>
    </div>

    <div class="paginator-shell">
      <mat-paginator
        [pageSizeOptions]="[10, 25, 50, 100]"
        [pageSize]="25"
        showFirstLastButtons
        (page)="onPage($event)"
      ></mat-paginator>
    </div>
  </div>

  <ng-template #emptyState>
    <div class="empty-state">
      <mat-icon class="empty-icon">inbox</mat-icon>
      <h3>Sin resultados</h3>
      <p>No hay OS para mostrar con los filtros actuales.</p>
    </div>
  </ng-template>
</ng-template>
